import { render, staticRenderFns } from "./ModifyReceptionDetails.vue?vue&type=template&id=ac54c89a"
import script from "./ModifyReceptionDetails.vue?vue&type=script&lang=js"
export * from "./ModifyReceptionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports